"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CacheInterface_1 = require("../CacheInterface");
/**
 * A class that provides an interface to manage different locales
 * and translations on a website.
 */
var LocaleParser = /** @class */ (function () {
    /**
     * Create a new instance of a LocalParser
     */
    function LocaleParser() {
        this.cache = new CacheInterface_1.CacheInterface();
    }
    /**
     * Load a LocalMap (or json file) and add it to the local library.
     *
     * @param localMap {LocaleMapType}
     * @param prefix {String|null}
     */
    LocaleParser.prototype.loadTranslations = function (localMap, prefix) {
        if (prefix === void 0) { prefix = null; }
        /*
         * Loop through every item in the map and add it to the cache.
         */
        for (var i in localMap) {
            if (localMap.hasOwnProperty(i)) {
                /*
                 * Add the item to the cache.
                 */
                this.cache.set(LocaleParser.generateKey(i, prefix), localMap[i]);
            }
        }
    };
    /**
     * Translate a key into it's value
     * @param identifier {string} the identifier to look for
     * @param section {string|null} the value to add to the start of the key
     * @param replaceArray
     * @param fallback
     */
    LocaleParser.prototype.get = function (identifier, section, replaceArray, fallback) {
        if (section === void 0) { section = null; }
        if (replaceArray === void 0) { replaceArray = null; }
        if (fallback === void 0) { fallback = null; }
        var formattedKey = LocaleParser.generateKey(identifier, section);
        var value = this.cache.get(formattedKey, fallback);
        if (replaceArray !== null) {
            return LocaleParser.replaceValues(value, replaceArray);
        }
        return value;
    };
    /**
     * Sets a Translation value for a specific identifier.
     * @param identifier {string}
     * @param value {any}
     * @param section {string|null}
     */
    LocaleParser.prototype.set = function (identifier, value, section) {
        if (section === void 0) { section = null; }
        this.cache.set(LocaleParser.generateKey(identifier, section), value);
    };
    /**
     * Replaces sections of a string with replacement pairs provided.
     * @param value {string} the base string
     * @param replaceArray { [key: string]: any } The replacement pairs array
     */
    LocaleParser.replaceValues = function (value, replaceArray) {
        /*
         * Only run if we have keys to replace
         */
        if (Object.keys(replaceArray).length > 0) {
            for (var key in replaceArray) {
                /*
                 * Make sure the key exists (JS check)
                 */
                if (replaceArray.hasOwnProperty(key)) {
                    /*
                     * Build a regex so all instances can be replaced
                     */
                    var regex = new RegExp(key, "g");
                    value = value.replace(regex, replaceArray[key]);
                }
            }
        }
        return value;
    };
    /**
     * Generates an index key based on an identifier and a section
     * @param identifier {string}
     * @param section {string|null}
     */
    LocaleParser.generateKey = function (identifier, section) {
        return section !== null ? section + ":" + identifier : identifier;
    };
    return LocaleParser;
}());
exports.LocaleParser = LocaleParser;
//# sourceMappingURL=data:application/json;base64,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